import React, { useState, Fragment } from 'react'
import store from '../../api/store'
import { apiEnv } from '../../api/url'
import { capitalize } from 'inflection'
import { Select, StackView, Box, Icon } from '@planningcenter/tapestry-react'
import { Text, Link } from '../shared/typography'
import { colors } from '../theme'

export default function SourceSwitcher() {
  const [isOpen, setIsOpen] = useState(false)

  if (process.env.NODE_ENV !== 'development') {
    return null
  }

  const handleSourceChange = ({ value }) => {
    store.set('apiSource', value)
    window.location.reload()
  }

  return (
    <Fragment>
      <StackView
        axis="vertical"
        onClick={() => setIsOpen(!isOpen)}
        backgroundColor={colors['primary']}
        style={{ cursor: 'pointer' }}
      >
        <StackView
          axis="horizontal"
          alignment="center"
          paddingHorizontal={1}
          paddingVertical={0.5}
        >
          <Icon
            name={isOpen ? 'general.downChevron' : 'general.rightChevron'}
            size="xs"
            color="#fff"
            marginRight={0.75}
          />
          <Text color="#fff">
            API Source: <strong>{capitalize(apiEnv)}</strong>
          </Text>
        </StackView>
      </StackView>
      {isOpen && (
        <Box
          padding={2}
          backgroundColor={colors['grey-2']}
          borderBottom={`1px solid ${colors['grey-5']}`}
        >
          <Select defaultValue={apiEnv} onChange={e => handleSourceChange(e)}>
            <Select.Option value="production">Production</Select.Option>
            <Select.Option value="staging">Staging</Select.Option>
            <Select.Option value="development">Development</Select.Option>
          </Select>

          <Text
            paddingHorizontal={1}
            paddingVertical={0.5}
            size={4}
            color={colors['grey-8']}
            lineHeight={2}
            marginTop={0.5}
          >
            Switch between API endpoint environments. If in "development", make
            sure{' '}
            <Link to="https://github.com/ministrycentered/pco-box" external>
              pco-box
            </Link>{' '}
            is running.
          </Text>
        </Box>
      )}
    </Fragment>
  )
}
